module.exports = TipTap;


//////////////////
// WEBPACK FOOTER
// external "TipTap"
// module id = 262
// module chunks = 0 1